import React from "react";

import HealthArrow from "$components/health-arrow";
import LargeNumber from "$components/info-list/content/large-number";

import { checkIsHealthyByChange } from "$utils/health-helper";

import "./amount-with-change.scss";
import { formatUIValue } from "$utils/number-helper";
import _ from "lodash";

const AmountWithChange = ({ value, changeValue = null, changePercent = null, isHealthy, changeText = "Monthly Change" }) => {
    const arrowIncrease = typeof isIncrease == "boolean" ? isIncrease : checkIsHealthyByChange(value);
    return (
        <div className="amount-with-change">
            <LargeNumber value={value} isHealthy={isHealthy} />
            {!_.isNull(changePercent) && (
                <div className="amount-change-group">
                    {changeText && <h5>{changeText}</h5>}
                    <div className="amount-change">
                        <h4 className="txt -white">{formatUIValue(changeValue)}</h4>
                        <HealthArrow isIncrease={arrowIncrease} />
                        <h4>
                            {formatUIValue(changePercent)}
                            <sup>%</sup>
                        </h4>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AmountWithChange;
